import * as types from '../mutation-types.js'

const state = {
  footerSections: [],
  textPage: {},
  footerSectionsCreateDialog: false,
}
 
const actions = {
  setFooterSections({ commit }, payload) {
    commit(types.FETCH_TEXTPAGE_FOOTER_SECTIONS_SUCCESS, payload)
  },
  setTextPage({ commit }, payload) {
    commit(types.FETCH_TEXTPAGE_SUCCESS , payload)
  },
}
 
const mutations = {
  [types.FETCH_TEXTPAGE_FOOTER_SECTIONS_SUCCESS] (state, payload) {
    state.footerSections = payload
  },
  [types.FETCH_TEXTPAGE_SUCCESS] (state, payload) {
    state.textPage = payload
  },
  openFooterSectionCreateDialogPopup(state, payload) {
    state.footerSectionsCreateDialog = payload
  }
}

const getters = {
  footerSections: state => state.footerSections,
  textPage: state => state.textPage,
  footerSectionsCreateDialog: state => state.footerSectionsCreateDialog,
}
 
export default {
  state,
  actions,
  mutations,
  getters
}
